// extracted by mini-css-extract-plugin
export default {"root":"empty-drop-zone_root__uH-WQ","body":"empty-drop-zone_body__EkIIH"};